<script setup>
import {ref, watch} from "vue";

  const props = defineProps({
    api_url: '',
    link_name: '',
    link_icon: '',
    isNew: {type: Boolean, default: false},
  });
  const showNew = ref(props.isNew);
  watch(() => props.isNew, (newVal) => {
    showNew.value = newVal;
  });
</script>

<template>
  <li class="nav-item">
    <router-link :to="api_url" class="nav-link">
      <i class="nav-icon fas "
        :class="link_icon"
      ></i>
      <p>
        {{ link_name }}
        <span
          v-if="showNew"
          class="right badge badge-danger"
          @click="showNew = !showNew"
        >Новое</span>
      </p>
    </router-link>
  </li>
</template>

<style scoped>

</style>